// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"hW-z","inlineTitle":"iW-z","sponsoredAdsWrapper":"jW-z","marketplaceRecosWrapper":"kW-z"};